import { Body, Box, Container, HStack } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import React, { useState } from 'react';
import TabItemMobile from './TabItemMobile';

const renderBody = (tabName: string) => {
  switch (tabName) {
    case 'problem':
      return (
        <Body size={500}>
          Rapid Roofing wanted to distinguish themselves from the high-pressure,
          murky sales approach employed by their competition.
        </Body>
      );
    case 'solution':
      return (
        <Body size={500}>
          Customers feel confident knowing that there’s nothing being hidden.
          After adopting HOVER, close rates on siding jobs increased from 30% to
          75%.
        </Body>
      );
    case 'products':
      return (
        <Box flexDir="column">
          <Body mb={100} size={500}>
            Measurements PDF
          </Body>
          <Body size={500}>Design in 3D</Body>
        </Box>
      );
    default:
      return (
        <Body size={500}>
          Sed ut perspiciatis unde omnis iste natus error sit voluptatem
          accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
          ab illo inventore veritatis et quasi architecto beatae.
        </Body>
      );
  }
};

const SlideMobile: React.FC = () => {
  const [currentSection, setCurrentSection] = useState<string>('problem');

  const onTabSelect = (title: string) => {
    setCurrentSection(title);
  };

  return (
    <Box
      d={{ base: 'block', desktop: 'none' }}
      w="100%"
      flexDir="column"
      alignItems="flex-start"
    >
      <Container px={0}>
        <StaticImage
          loading="lazy"
          objectFit="contain"
          placeholder="blurred"
          alt="real time 3d"
          src="../../../assets/images/exterior_contractor_case_study_1.png"
        />
        <Box
          p={400}
          w="100%"
          bg="brandNavy.500"
          mt={200}
          borderRadius="0 0 8px 8px"
          shadow="distance300"
          mb={700}
        >
          <Body size={300} color="neutral.0" isSemiBold>
            Rapid Roofing is a residential and commercial exterior contractor in
            Southeast Michigan. The company was founded by brothers Bill and
            Mike Beaty, who grew up working in the roofing industry alongside
            their father.
          </Body>
        </Box>
        <HStack spacing="auto" mb={700}>
          <TabItemMobile
            onSelect={onTabSelect}
            title="problem"
            isActive={currentSection === 'problem'}
          />
          <TabItemMobile
            onSelect={onTabSelect}
            title="solution"
            isActive={currentSection === 'solution'}
          />
          <TabItemMobile
            onSelect={onTabSelect}
            title="products"
            isActive={currentSection === 'products'}
          />
        </HStack>
        {renderBody(currentSection)}
      </Container>
    </Box>
  );
};

export default SlideMobile;
